module.exports = __webpack_public_path__ + "img/15600.c5618c3d.jpg";